import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLockOpen, faLock } from "@fortawesome/free-solid-svg-icons";

import { getDefaultValueByType, isEmptyByType } from "../../attributes/lib/attribute-data";

const Lockable = (WrappedComponent) => (props) => {
    //TODO: function to determine if a dataType has a value Ex: [] technically is no value
    const currentValue = (props.defaultValue ? props.defaultValue : props.value) || getDefaultValueByType(props.dataType);
    // Defaults to unlocked if attribute has no value
    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [locked, setLocked] = useState(!isEmptyByType(currentValue, props.dataType));

    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (props.reset) {
            const isLocked = !isEmptyByType(props.defaultValue ? props.defaultValue : props.value, props.dataType);
            setLocked(isLocked);
        }
    }, [props.reset]);

    if (!props.lockable || props.readOnly || props.disabled) {
        return <WrappedComponent {...props} />;
    }

    const toggleLocked = () => {
        setLocked(!locked);
    };

    return (
        <div className="lockable-wrapper">
            <WrappedComponent {...props} disabled={locked} />
            <button className="button -small" onClick={toggleLocked}>
                <FontAwesomeIcon icon={locked ? faLock : faLockOpen} />
            </button>
        </div>
    );
};

export default Lockable;
